import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InventoryRoutingModule } from './inventory-routing.module';
import { InventoryItemComponent } from './inventory-item/inventory-item.component';
import { AddInventoryItemComponent } from './add-inventory-item/add-inventory-item.component';
import { InventoryDocumentsComponent } from './inventory-documents/inventory-documents.component';
import { InventoryIbnComponent } from './inventory-ibn/inventory-ibn.component';
import { ViewInventoryComponent } from './view-inventory/view-inventory.component';
import { ViewTravelersComponent } from './view-travelers/view-travelers.component';
import { TravelerComponent } from './traveler/traveler.component';
import { NgxMaskModule } from 'ngx-mask';
import { InventoryComponent } from './inventory/inventory.component';

import { SharedModule } from '../../shared/shared.module';
import { InventoryGroupConfigComponent } from './inventory-group-config/inventory-group-config.component';
import { InventoryGroupPopupComponent } from './inventory-group-config/inventory-group-popup/inventory-group-popup.component';
import { InventoryExpendedSearchComponent } from './inventory-expended-search/inventory-expended-search.component';
import { InventoryAdjustmentPopupComponent } from './view-inventory/inventory-adjustment-popup/inventory-adjustment-popup.component';
import { InventoryMovePopupComponent } from './inventory-item/inventory-move-popup/inventory-move-popup.component';
import { ManuallyExpendedComponent } from './manually-expended/manually-expended.component';
import { AddInventoryToCartPopupComponent } from './view-inventory/add-inventory-to-cart-popup/add-inventory-to-cart-popup.component';
import { InventoryCartPopupComponent } from './view-inventory/inventory-cart-popup/inventory-cart-popup.component';
import { InventoryReceivedSearchComponent } from './inventory-received-search/inventory-received-search.component';
import { ImportInventoryComponent } from './import-inventory/import-inventory.component';
import { AutoreorderDirective } from './inventory-item/autoreorder.directive';
import { TravelerConfigComponent } from './travelerConfig/travelerConfig.component';

@NgModule({
  declarations: [
        InventoryItemComponent,
        TravelerComponent,
        ViewTravelersComponent,
        ViewInventoryComponent,
        InventoryIbnComponent,
        AddInventoryItemComponent,
        InventoryDocumentsComponent,
        InventoryComponent,
        InventoryGroupConfigComponent,
        InventoryGroupPopupComponent,
        InventoryExpendedSearchComponent,
        InventoryAdjustmentPopupComponent,
        InventoryMovePopupComponent,
        ManuallyExpendedComponent,
        AddInventoryToCartPopupComponent,
        InventoryCartPopupComponent,
        InventoryReceivedSearchComponent,
        ImportInventoryComponent,
        AutoreorderDirective,
        TravelerConfigComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    InventoryRoutingModule,
    NgxMaskModule.forRoot()
  ],
    exports: [
      AddInventoryItemComponent
    ]
})
export class InventoryModule { }
